export interface SegmentoBarra {
  clave: string;
  etiqueta: string;
  /** Sólo para la proporción (cantidades, m²): no se hacen cuentas de plata con esto. */
  valor: number;
  /** Lo que muestra la leyenda ("2", "48 m²"); por defecto, el valor. */
  texto?: string;
  /** Token CSS del color ("--color-exito"). */
  token: string;
}

export interface BarraApiladaProps {
  etiqueta: string;
  segmentos: SegmentoBarra[];
  /** Muestra abajo cada segmento con su color, su etiqueta y su texto. */
  leyenda?: boolean;
}

/** Una barra partida en segmentos proporcionales (estados de las unidades, superficies), con su leyenda. */
export function BarraApilada({ etiqueta, segmentos, leyenda = true }: BarraApiladaProps) {
  const visibles = segmentos.filter((s) => s.valor > 0);
  const resumen = segmentos.map((s) => `${s.etiqueta} ${s.texto ?? s.valor}`).join(", ");
  return (
    <div className="flex flex-col gap-2">
      <div role="img" aria-label={`${etiqueta}: ${resumen}`} className="flex h-1.5 gap-0.5 overflow-hidden rounded-full bg-carbon/10">
        {visibles.map((s) => (
          <span key={s.clave} className="h-full" style={{ flexGrow: s.valor, flexBasis: 0, backgroundColor: `var(${s.token})` }} />
        ))}
      </div>
      {leyenda && (
        <ul aria-hidden className="flex flex-wrap gap-x-4 gap-y-1 text-chico text-texto-suave">
          {segmentos.map((s) => (
            <li key={s.clave} className="inline-flex items-center gap-1.5">
              <span className="size-2 rounded-full" style={{ backgroundColor: `var(${s.token})` }} />
              {s.etiqueta}
              <span className="font-semibold tabular-nums text-texto">{s.texto ?? s.valor}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
